import { Form, Formik } from 'formik';
import React from 'react';

import DropdownField from '@components/Form/DropdownField';
import { SCOPE_ARTICLES, SCOPE_DIRECTORY, SCOPE_FORUM } from '@hooks/useSearchResults';
import { search_page_path } from '@routes';
import { AutocompleteOption } from '@utils/interfaces';

import styles from './styles.module.scss';

const TAB_NAMES = [SCOPE_ARTICLES, SCOPE_FORUM, SCOPE_DIRECTORY];

interface SearchTabValues {
  tabName: AutocompleteOption;
}

const TAB_OPTIONS: AutocompleteOption[] = TAB_NAMES.map((tab) => ({ label: tab, value: tab }));

const SearchTabs = ({ query, scope }) => {
  const handleTabChange = (values: SearchTabValues) => {
    window.location.href = search_page_path({
      query,
      scope: values.tabName.value,
    });
  };

  return (
    <>
      <div className="search-scope-tabs">
        {TAB_NAMES.map((tab) => (
          <a
            key={tab}
            href={search_page_path({ query, scope: tab })}
            className={`tab-control ${scope === tab && '--red'}`}
          >
            {tab}
          </a>
        ))}
      </div>
      <div className={styles.mobileTabSection}>
        <Formik initialValues={{ tabName: TAB_OPTIONS[0] }} onSubmit={handleTabChange}>
          {(formik) => (
            <Form onSubmit={formik.handleSubmit} className={styles.formContainer}>
              <DropdownField
                className="w-full"
                name="tabName"
                options={TAB_NAMES.map((tab) => ({ label: tab, value: tab }))}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default SearchTabs;
